import { styled } from '@mui/material';

export const classes = {
  root: 'root',
  mainSection: 'mainSection',
  remainSpaceParentBox: 'remainSpaceParentBox',
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    backgroundColor: theme.palette.secondaryWhite.main,
  },
  [`& .${classes.mainSection}`]: {
    display: 'flex',
    backgroundColor: theme.palette.secondaryWhite.main,
  },
  [`& .${classes.remainSpaceParentBox}`]: {
    height: `calc(100vh - ${theme.spacing(6)})`,
    transition: 'all 0.4s ease 0s',
  },
}));
